import cx from 'classnames';

import { useCandidateMatches } from 'lib/providers/CandidateMatchesProvider';

import styles from './MatchesProgress.module.scss';

export const MatchesProgress = ({ className, currentMatchSlug }: { className?: string; currentMatchSlug?: string }) => {
  const { isMatchesLoading, opportunityMatches } = useCandidateMatches();
  const progress =
    isMatchesLoading || opportunityMatches.length === 0
      ? 0
      : currentMatchSlug
      ? ((opportunityMatches.findIndex((match) => match.matchable_slug === currentMatchSlug) + 1) / (opportunityMatches.length + 1)) * 100
      : 100;

  return (
    <div
      className={cx(styles.container, className, {
        [styles['no-background']]: isMatchesLoading,
      })}
    >
      <div className={styles.progress} style={{ width: `${progress}%` }}></div>
    </div>
  );
};
